import { faInfoCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";

const EmptyHerbInfoPopup = ({ closePopup, days }) => {
  const dispatch = useDispatch();

  return (
    <Modal show={true} id="prescription-popup" size="lg">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12" style={{ color: "white" }}>
                  <h2 className="heading">
                    Please create your formula in RAW and convert to granular
                    when ready.
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 200, hide: 100 }}
                      overlay={
                        <Tooltip id="prescription-tooltip">
                          <p style={{ textAlign: "left" }}>
                            We have solved one of herbal medicine’s biggest
                            challenges: granular herb dosing.
                            <br /> <br /> ✅ Quality Herbs are no longer
                            granulated at a universal 5:1 ratio. Different
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;concentrations
                            are now used to optimize potency and quality. This
                            makes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;converting
                            herbs from raw to granular very difficult.
                            <br /> <br /> ✅ “3 scoops twice daily” serving
                            instructions is outdated and inaccurate. Each
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;formula has a
                            unique therapeutic dose (grams/day). Some formulas
                            maybe 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;scoops
                            and another 10 scoops per day.
                            <br /> <br /> ✅ Dosage vs. Dosing: <br /> <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dosage = amount
                            in grams per herb in a formula.
                            <br /> <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dosing
                            (therapeutic dose) = how much of the finished
                            formula to be taken per
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;day. In Raw the
                            standard daily dose of a formula is 1 Packet per day
                            whereas in
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;granular it is
                            the number of grams per day (needs to be
                            calculated).
                            <br /> <br />
                            ⭐Start by writing your formulas in RAW, and MHP
                            will auto-convert to granular AND
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;provide the
                            recommended daily therapeutic dose! This is a huge
                            leap for our
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;industry—and
                            we’re proud to lead the way. <br /> <br />
                          </p>
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                      />
                    </OverlayTrigger>
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <button className="btn-orange" onClick={closePopup}>
              Ok
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default EmptyHerbInfoPopup;
